'use strict'

{ uniqueId } = require '../../../src/frontend/helper/general/m_underscore_replacements'

Groupon.Keymap =
  'TAB'       : 9
  'ENTER'     : 13
  'ESCAPE'    : 27
  'SPACE'     : 32
  'END'       : 35
  'HOME'      : 36
  'LEFT'      : 37
  'UP'        : 38
  'RIGHT'     : 39
  'DOWN'      : 40
  'DELETE'    : 46


class window.Groupon.AriaMenuNavigation
  initMenuNavigation: ($menuTrigger, $menu, $menuLinks, menuTriggerParent) ->
    @$menuTrigger = $menuTrigger
    @$menu = $menu
    @$menuLinks = $menuLinks

    @initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent)
    @bindMenu()

  initAriaAttributes: ($menuTrigger, $menu, $menuLinks, menuTriggerParent) ->
    # check if menu exists
    if $menu.length
      menuExists = true
      # make sure the menu & menuTrigger have an unique id
      $menu[0].id = uniqueId('sls-aria-') unless $menu[0].id
      menuID =  $menu[0].id

    $menuTrigger[0].id = uniqueId('sls-aria-') unless $menuTrigger[0].id

    $menuTrigger.attr({
      'role': 'menuitem'
      'aria-haspopup': menuExists
      'aria-owns': menuID
      'tabindex': '0'
    })

    $triggerWrapper = @ariaFindClosestParent($menuTrigger, menuTriggerParent)
    $triggerWrapper.attr({
      'role': 'menubar'
    })

    return unless menuExists
    $menu.attr({
      'role': 'menu'
      'aria-hidden':'true'
      'aria-labelledby': $menuTrigger[0].id
    })
    if not $menuLinks.length
      $menu.attr('role', null)

    $menuLinks.attr({
      'tabindex': '-1'
      'role': 'menuitem'
    })

  ariaFindClosestParent: ($source, selector = '') ->
    # find closest parent element for the menu trigger
    # skip assumption if @menuTriggerParent is given
    unless selector
      if $source.parent()[0].nodeName is 'LI'
        # assuming ul-li parent structure
        selector = 'ul'
      else
        # assuming nav html5 parent structure
        selector = 'nav'
    # if no element is found search for the closest div
    $parent = $source.closest(selector)
    $parent = if $parent.length then $parent else $source.closest('div')

  bindMenu: ->
    @ariaBindMenuTrigger(@$menuTrigger)
    @ariaBindMenuLinks()

  ariaBindMenuTrigger: ($trigger = @$menuTrigger) ->
    $trigger.off 'keydown'
    $trigger.on 'keydown', (e) =>
      {SPACE, DOWN} = Groupon.Keymap
      if e.keyCode in [SPACE, DOWN]
        @$menu.attr('aria-hidden', 'false').show()
        @$menuLinks.eq(0).focus().attr('tabindex', 0)

  ariaBindMenuLinks: ->
    @$menuLinks.off 'keydown'
    @$menuLinks.on 'keydown', (e) =>
      keycode = e.keyCode
      {UP, DOWN, ESCAPE, TAB} = Groupon.Keymap
      # if ESC, TAB pressed within the subnav: close menu + focus on trigger
      if keycode in [ESCAPE, TAB]
        e.keyCode = ESCAPE
        @ariaCloseMenu(@$menuTrigger)
        # focus previous link
      else
        linkIndex = $.inArray(e.currentTarget, @$menuLinks)
        # key "arrow up"
        if keycode is UP
          # if key "arrow up" the first link -> close menu
          if linkIndex is 0
            # when focus is on the first link focus on last link
            @ariaResetIndex(linkIndex)
            @ariaBrowseLinks(@$menuLinks.length - 1, 0)
          else
            # focus previous link
            @ariaBrowseLinks(linkIndex, -1)
        # key "arrow down"
        if keycode is DOWN
          if linkIndex is @$menuLinks.length - 1
            #when focus was on the last link focus on the first link
            @ariaResetIndex(linkIndex)
            @ariaBrowseLinks(0, 0)
          else
            #focus on next link
            @ariaBrowseLinks(linkIndex, 1)

  ariaBrowseLinks: (i, sibling) ->
    @ariaResetIndex(i)
    @$menuLinks.eq(i + sibling).focus().attr('tabindex', '0')

  ariaResetIndex: (i) ->
    @$menuLinks.eq(i).attr('tabindex', '-1')

  ariaCloseMenu: ($trigger = @$menuTrigger) ->
    @$menu.attr('aria-hidden', 'true').hide()
    #reset tabindex
    @$menuLinks.attr('tabindex', '-1')
    $trigger.focus()
